import { Outlet } from "react-router-dom";
import PageHeader from "./PageHeader";
import { IsPrivileged } from "./DisplayChildElement";
import { useLocation } from "react-router-dom";

export default function InnerPageLayout({
  Nav,
  name,
  description,
  icon,
  sideComponent,
}) {
  const location = useLocation();

  const segments = location?.pathname?.split("/")?.filter(Boolean);
  const lastSegment = segments[segments?.length - 1];

  return (
    <>
      <main className="inner-page-outlet">
        {name && (
          <div className="d-flex justify-content-between bg-white align-items-center">
            <PageHeader {...{ name, description, icon }} />

            {/* {sideComponent &&
              ["customer-overview"].includes(lastSegment) &&
              sideComponent} */}
            {sideComponent && sideComponent}
          </div>
        )}

        {Nav && <div className="nav-bar">{Nav}</div>}

        <Outlet />
      </main>
    </>
  );
}

//InvoicePageHeader
